var map = {
	"./app.js": 9638,
	"./dict.js": 9173,
	"./discount.js": 9643,
	"./errorLog.js": 6386,
	"./label.js": 1618,
	"./list.js": 5498,
	"./permission.js": 6042,
	"./quote.js": 2157,
	"./tagsView.js": 6941,
	"./user.js": 9416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2645;